import styled from 'styled-components'

export const Subtitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: ${({ emailCopyTitle }) => (emailCopyTitle ? '24px' : '32px')};
`
